import {Component} from '@angular/core';

@Component({
  selector: 'voice-mail-node',
  templateUrl: './voice-mail-node.component.html'
})
export class VoiceMailNodeComponent {
    node
}
